const mediaQueries = {
    mobile: '@media (min-width: 321px)',
    tablet: '@media (min-width: 429px)',
    largeTablet: '@media (min-width: 440px)',
    laptop: '@media (min-width: 768px)',
    largeLaptop: '@media (min-width: 992px)',
    tabletLandscape: '@media (min-width: 1024px)',
    smallDesktop: '@media (min-width: 1366px)',
    desktop: '@media (min-width: 1440px)',
    largeDesktop: '@media (min-width: 1900px)',
};

export default mediaQueries;
